import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flicker"
export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.startFlicker()
  }

  disconnect() {
    window.clearInterval(this.flickerTimer)
    this.flickerTimer = null
  }

  startFlicker() {
    this.disconnect()
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return
    this.flickerTimer = window.setInterval(() => {
      const opacity = Math.random() > 0.98 ? 0.55 : 0.03
      if (this.hasImageTarget) {
        this.imageTarget.style.opacity = opacity
      }
    }, 5000)
  }
}
